import * as amplitude from '@amplitude/analytics-browser'
import { type UTMParams } from '#app/constants/utm-types'

export const trackProductCardClick = (
	product: any,
	index: number,
	location: any,
	utmParams: UTMParams,
) => {
	const searchParams = new URLSearchParams(location.search)

	const eventData = {
		brands: searchParams.get('brand') || product.brand || '',
		category: product.categories ? product.categories.join(', ') : '',
		colours:
			searchParams.get('color') ||
			(product.colors ? product.colors.join(', ') : ''),
		gender: product.gender || '',
		sizes:
			searchParams.get('size') ||
			(product.data
				? JSON.parse(product.data)
						.map((store: any) => store.prices.map((price: any) => price.size))
						.flat()
						.join(', ')
				: ''),
		Material: searchParams.get('materials') || product.material || '', // Assuming material is a property of product
		sortingOrder: searchParams.get('sort') || '', // Assuming sorting order is in search params
		storePagePLP: location.pathname,
		utm_campaign: utmParams?.utm_campaign || '',
		utm_medium: utmParams?.utm_medium || '',
		utm_source: utmParams?.utm_source || '',
	}


	amplitude.track('Product Card Clicked', eventData)
}
